import React, {FunctionComponent} from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';

const IconRight: FunctionComponent<IconProps> = ({
  className, height, title,
}) =>
  (
    <Icon className={className} height={height} title={title}>
      M8.79289 10.2071C8.89052 10.1095 8.89052 9.95118 8.79289 9.85355L0.353553 1.41421C0.158291 1.21895 0.158291
      0.902369 0.353553 0.707107L0.707107 0.353553C0.902369 0.158291 1.21895 0.158291 1.41421 0.353553L10.7374
      9.67678C10.9327 9.87204 10.9327 10.1886 10.7374 10.3839L1.41421 19.7071C1.21895 19.9024 0.902369 19.9024 0.707107
      19.7071L0.353553 19.3536C0.158291 19.1583 0.158291 18.8417 0.353553 18.6464L8.79289 10.2071Z </Icon>
  );

export default IconRight;
